module.exports = __webpack_public_path__ + "static/media/Tag_OCR.b5e9dab7.svg";